import { jsxs as h, jsx as i } from "react/jsx-runtime";
import { forwardRef as v } from "react";
import c from "classnames";
import B from "../../helpers/nanoid.js";
const R = "forma-ui__switcher__container", S = "forma-ui__switcher__hidden", g = "forma-ui__switcher__fullWidth", q = "forma-ui__switcher__inputContainer", A = "forma-ui__switcher__input", D = "forma-ui__switcher__label", E = "forma-ui__switcher__small", G = "forma-ui__switcher__icon", H = "forma-ui__switcher__button", I = "forma-ui__switcher__errorText", J = "forma-ui__switcher__notice", K = "forma-ui__switcher__icons", n = {
  container: R,
  hidden: S,
  fullWidth: g,
  inputContainer: q,
  input: A,
  label: D,
  small: E,
  icon: G,
  button: H,
  errorText: I,
  notice: J,
  icons: K
}, V = v(({
  id: r = B(8),
  name: f,
  onChange: e,
  onFocus: s,
  onBlur: a,
  hidden: d,
  fullWidth: p,
  label: _,
  size: o = "medium",
  className: w,
  containerClass: b,
  labelClass: x,
  iconClass: N,
  error: l,
  errorMessage: m,
  success: C,
  notice: u,
  placeholder: L,
  checked: T,
  ...W
}, j) => {
  const y = (t) => {
    e && e(t);
  }, F = (t) => {
    s && s(t);
  }, k = (t) => {
    a && a(t);
  };
  return /* @__PURE__ */ h("div", { className: c(n.container, p && n.fullWidth, b, d && n.hidden), children: [
    /* @__PURE__ */ h("label", { className: n.inputContainer, htmlFor: r, children: [
      /* @__PURE__ */ i(
        "input",
        {
          ...W,
          type: "checkbox",
          id: r,
          name: f,
          onChange: y,
          onFocus: F,
          onBlur: k,
          className: c(
            n.input,
            w,
            o && n[o],
            l && "error",
            C && "success"
          ),
          checked: T,
          ref: j
        }
      ),
      /* @__PURE__ */ i("span", { className: c(n.icon, N, o && n[o]) }),
      _ && /* @__PURE__ */ i("span", { className: c(n.label, x), children: _ })
    ] }),
    l && m && /* @__PURE__ */ i("span", { className: n.errorText, children: m }),
    u && /* @__PURE__ */ i("span", { className: n.notice, children: u })
  ] });
});
export {
  V as default
};
